import { computed } from 'mobx';
import { Collection } from 'core/model/Collection';
import generateLayout, { newPanelLayout } from 'app/stores/boards/generateLayout';
import BoardPanelModel, { BoardPanelJson } from './BoardPanelModel';
import BoardModel from './BoardModel';

class BoardPanelCollection extends Collection<BoardPanelModel> {
  public readonly parent: BoardModel;

  constructor(data: BoardPanelJson[] = [], { parent }: { parent: BoardModel }) {
    super(data);
    this.parent = parent;
  }

  get url() {
    return `/api/ui/boards/${this.parent.id}/panel`;
  }

  get model() {
    return BoardPanelModel;
  }

  forge: Collection<BoardPanelModel>['forge'] = (attributes, options = {}) => {
    const layouts =
      'parent_panel_id' in attributes && attributes.parent_panel_id
        ? this.get(Number(attributes.parent_panel_id))?.layout || generateLayout([])
        : this.parent.layout;

    // initialize panel layout
    attributes.layout = newPanelLayout(layouts, 'toJS' in attributes ? attributes.toJS() : attributes || {});

    return this.build(attributes, options);
  };

  hasPanelOfType(type: string) {
    return this.models.some((m) => m.get('type') === type);
  }

  @computed
  get hasUdePanel() {
    return this.hasPanelOfType('ude');
  }

  @computed
  get topLevelPanels() {
    return this.models.filter((m) => !m.get('parent_panel_id'));
  }

  getSubPanels(parentPanelId: number | string) {
    return this.models.filter((m) => `${m.get('parent_panel_id')}` === `${parentPanelId}`);
  }
}

export default BoardPanelCollection;
